<template>
  <app-layout centered title="Settings" class="tabs-container">
    <template v-slot:body>
      <div class="container col-lg-10 col-sm-12">
        <v-tabs
          class="basic-tabs"
          v-model="selectedTab"
          centered
          @change="handleTabChange"
        >
          <v-tab v-for="section in sections" :key="section">
            {{ section | startCase }}
          </v-tab>
        </v-tabs>
      </div>
      <router-view />
    </template>
  </app-layout>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
import appLayout from "@/components/common/base-layouts/AppLayout";
import { MAIN_NAVIGATION_ITEMS } from "@/router/constants";
import { AUTH_NAMESPACE } from "@/store/modules/auth";
import { last } from "lodash";

const { SETTINGS } = MAIN_NAVIGATION_ITEMS;
const { mapState } = createNamespacedHelpers(AUTH_NAMESPACE);

export default {
  title: "Settings - Track",
  name: "SettingsTab",
  components: { appLayout },
  data() {
    return {
      selectedTab: this.initialSection
    };
  },
  created() {
    this.selectedTab = this.initialSection;
  },
  methods: {
    handleTabChange(selectedTab) {
      const tabName = this.sections[selectedTab];
      this.$router.replace(`/${SETTINGS}/${tabName}`);
    }
  },
  computed: {
    ...mapState({
      permissions: state => state.permissions
    }),
    sections() {
      return [
        "profile",
        this.permissions["settings.edit-notifications"] && "notifications",
        this.permissions["settings.edit-organisation"] && "organisation",
        this.permissions["settings.edit-booking-templates"] && "roles",
        this.permissions["settings.publishing-schedules.view"] &&
          "publishing-schedules",
        this.permissions["settings.view-org-users"] && "users",
        this.permissions["settings.edit-message-templates"] && "messages",
        this.permissions["settings.edit-interview-templates"] && "interviews",
        this.permissions["settings.application-question-templates.view"] &&
          "application-questions",
        this.permissions["settings.approval-chains.view"] && "approval-chains",
        this.permissions["settings.microsites.view"] && "microsites"
      ].filter(Boolean);
    },
    initialSection() {
      const sectionKey = last(this.$router.currentRoute.path.split("/"));
      return this.sections.indexOf(sectionKey);
    }
  }
};
</script>

<style lang="scss"></style>
